export default __webpack_public_path__ + "b6510b74044ad08c3bdf74eb46abd2c3.svg";